/* TONI HOMI Black Friday 2026 (th-bf). */
(function(){
  function parseEnd(v){ if(!v) return null; v=String(v).trim();
    var m=v.match(/^(\d{1,2})[-\/](\d{1,2})[-\/](\d{4})(?:\s+(\d{1,2}):(\d{2}))?$/); if(m) return new Date(+m[3],+m[2]-1,+m[1],m[4]?+m[4]:23,m[5]?+m[5]:59,59);
    var m2=v.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{1,2}):(\d{2}))?$/); if(m2) return new Date(+m2[1],+m2[2]-1,+m2[3],m2[4]?+m2[4]:23,m2[5]?+m2[5]:59,59);
    var d=new Date(v); return isNaN(d)?null:d; }
  function pad(n){return (n<10?'0':'')+n}
  function tickAll(){
    var now=new Date();
    document.querySelectorAll('[data-bf-cd]').forEach(function(el){
      var end=el.__end||(el.__end=parseEnd(el.getAttribute('data-end'))); if(!end) return;
      var ms=Math.max(0,end-now), d=Math.floor(ms/864e5), h=Math.floor(ms/36e5)%24, m=Math.floor(ms/6e4)%60, s=Math.floor(ms/1e3)%60;
      if(el.getAttribute('data-bf-cd')==='box'){
        var D=el.querySelector('[data-d]'),H=el.querySelector('[data-h]'),M=el.querySelector('[data-m]'),S=el.querySelector('[data-s]');
        if(D)D.textContent=pad(d); if(H)H.textContent=pad(h); if(M)M.textContent=pad(m); if(S)S.textContent=pad(s);
      } else { el.textContent=(d?d+'d ':'')+pad(h)+'u '+pad(m)+'m'; }
    });
  }
  function reveal(){
    var els=document.querySelectorAll('.bf-rv:not(.bf-in)');
    if(!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('bf-in')}); return; }
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('bf-in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px',threshold:.08});
    els.forEach(function(el){io.observe(el)});
  }
  function sticky(){
    var mcta=document.getElementById('thbf-mcta'),hero=document.getElementById('thbf-hero'),close=document.getElementById('thbf-deals');
    if(!mcta||mcta.__done||!('IntersectionObserver' in window)) return; mcta.__done=1;
    var heroVisible=!!hero,closeVisible=false;
    function upd(){mcta.classList.toggle('bf-show',!heroVisible&&!closeVisible)}
    if(hero) new IntersectionObserver(function(es){heroVisible=es[0].isIntersecting;upd()},{threshold:.15}).observe(hero);
    if(close) new IntersectionObserver(function(es){closeVisible=es[0].isIntersecting;upd()},{threshold:.2}).observe(close);
    setTimeout(upd,800);
  }
  function rails(){
    document.querySelectorAll('[data-rail]').forEach(function(rail){
      if(rail.__done) return; rail.__done=1;
      var hint=rail.parentElement.querySelector('.bf-rail-hint'); if(!hint) return;
      var dots=hint.querySelectorAll('i');
      rail.addEventListener('scroll',function(){
        var i=Math.round(rail.scrollLeft/Math.max(1,rail.scrollWidth-rail.clientWidth)*(dots.length-1));
        dots.forEach(function(d,k){d.classList.toggle('bf-on',k===i)});
      },{passive:true});
    });
  }
  function init(){ tickAll(); reveal(); sticky(); rails(); }
  if(!window.__thbf){ window.__thbf=1; setInterval(tickAll,1000);
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
    document.addEventListener('shopify:section:load',function(){ setTimeout(init,50); });
  } else { init(); }
})();
